import styled, { css } from 'styled-components'

export const Content = styled.div(
  ({ theme }) => css`
    position: relative;
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: ${theme.space['0']} ${theme.space['16']} ${theme.space['16']};
  `,
)

export const Logo = styled.img(
  ({ theme }) => css`
    width: auto;
    height: 6.8rem;
    padding: ${theme.space['4']} ${theme.space['0']};
  `,
)

export const SuccessfulPaymentContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    flex-direction: column;
    gap: ${theme.space['16']};
    padding: ${theme.space['16']};
    text-align: center;
    color: ${theme.colors.green500};
    background-color: ${theme.colors.green100};
    border-radius: ${theme.border.radius['8']};
  `,
)

export const Modules = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.space['24']};
  `,
)

export const Controls = styled.div<{ $hasSingleButton: boolean }>(
  ({ theme, $hasSingleButton }) => css`
    z-index: ${theme.zIndex.level1};
    position: sticky;
    bottom: 0;
    display: grid;
    grid-template-columns: ${$hasSingleButton ? '1fr' : 'auto 1fr'};
    gap: ${theme.space['8']};
    margin-top: auto;
    padding: ${theme.space['16']};
    background-color: ${theme.colors.white};
    box-shadow: ${theme.shadow.marketShopShadow};
  `,
)
